import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/institution-settings',
        name: 'institution-settings-parent',
        component: () => import('@/pages/administration/InstitutionSettings.vue'),
        props: true,
        meta: {
            title: 'Institution Settings',
            middleware: [GateKeeperMiddleware],
            ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
        },
        children: [
            {
                path: '',
                redirect: { name: 'institution-settings-profile' },
            },
            {
                path: 'profile',
                name: 'institution-settings-profile',
                component: () => import('@/components/administration/institution-settings/InstitutionProfile.vue'),
                meta: {
                    title: 'Institution Profile',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
                },
                props: true,
            },
            {
                path: 'contact-support',
                name: 'institution-settings-contact-support',
                component: () => import('@/components/administration/institution-settings/ContactSupport.vue'),
                meta: {
                    title: 'Contact & Support',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
                },
                props: true,
            },
            {
                path: 'email-reminders',
                name: 'institution-settings-email-reminders',
                component: () => import('@/components/administration/institution-settings/EmailReminders.vue'),
                meta: {
                    title: 'Email & Reminders',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
                },
                props: true,
            },
            {
                path: 'system-notifications',
                name: 'institution-settings-system-notifications',
                component: () => import('@/components/administration/institution-settings/SystemNotifications.vue'),
                meta: {
                    title: 'System Notifications',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
                },
                props: true,
            },
            {
                path: 'course-lifecycle-grades',
                name: 'institution-settings-course-lifecycle-grades',
                component: () => import('@/components/administration/institution-settings/CourseLifecycleGrades.vue'),
                meta: {
                    title: 'Course Lifecycle & Grades',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
                },
                props: true,
            },
            {
                path: 'identity-verification',
                name: 'institution-settings-identity-verification',
                component: () => import('@/components/administration/institution-settings/IdentityVerification.vue'),
                meta: {
                    title: 'Identity Verification',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
                },
                props: true,
            },
            /*{ disabled for now until we decide if we are going to use this
                path: 'risk-compliance-buffers',
                name: 'institution-settings-risk-compliance-buffers',
                component: () => import('@/components/administration/institution-settings/RiskComplianceBuffers.vue'),
                meta: {
                    title: 'Risk & Compliance Buffers',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
                },
                props: true,
            },*/
            {
                path: 'attestation',
                name: 'institution-settings-attestation',
                component: () => import('@/components/administration/institution-settings/Attestation.vue'),
                meta: {
                    title: 'Attestation',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gate }) => gate.allows('viewAny', 'InstitutionSetting'),
                },
                props: true,
            },
        ],
    },
];
